import { useEffect, useState } from 'react';
import { Icon } from 'mastodon/components/icon';
import api from 'mastodon/api';
import { store } from 'mastodon/store';
export default function DirectCounterIcon({ investigation = false }) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let active = true;
    const refresh = () => {
      if (document.hidden) return;
      api(store.getState).get('/api/v1/conversations/unread_count', { params: { channel: investigation ? 'investigation' : 'dm' } }).then(({ data }) => { if (active) setCount(data.count); }).catch(() => {});
    };
    refresh();
    const timer = setInterval(refresh, 30000);
    window.addEventListener('dm-read', refresh);
    return () => { active = false; clearInterval(timer); window.removeEventListener('dm-read', refresh); };
  }, [investigation]);
  return <span className='dm-counter column-link__icon' aria-hidden='true'><Icon id={investigation ? 'search' : 'envelope-o'} fixedWidth />{count > 0 && <span className='dm-counter__badge'>{count > 99 ? '99+' : count}</span>}</span>;
}
